export default __webpack_public_path__ + "static/media/ranjith.cbfcf257.png";